class StockLocationInventoryCountController extends AbstractStockLocationController
	@register()
	@inject 'translate',
		'InventoryCountRepository'
		'stockLocation'
		'shops'
		'ToastService'
		'SEARCH_CONFIGURATION'
		'inventoryCountStatusEnum': 'BACKEND_INVENTORY_COUNT_STATUS'

	initialize: ->
		super()

		@shops = angular.copy @shops
		@shops.push {
			id: '-1'
			name: '- ' + @translate('general.undefined') + ' -'
		}
		@shops = _.sortBy(@shops, 'name')
		@inventoryCounts = []

		@filterDTO = new FilterDTO({
			searchConfiguration: @SEARCH_CONFIGURATION.inventory_count
			pageSize: @InventoryCountRepository.getPageSize()
			count: 0
			sortProperty: 'timestamp'
		})

	search: ->
		@searching = true

		query = @filterDTO.getQuery()
		query.criteria('stock_location_id', '=', @stockLocation.id)

		@InventoryCountRepository
			.getEntitiesWithCount query
			.then (response) =>
				@inventoryCountItems = response.data

				@filterDTO.count = response.count

				for item in @inventoryCountItems
					if item.shop_id?
						item.shop_name = _.find(@shops, {id: item.shop_id})?.name
			.catch (response) =>
				@handleErrors response, 'inventory.count'

	getAdvancedSearchValues: (filterKey) ->
		if filterKey == 'shop_id'
			return @InventoryCountRepository.resolve(@shops)

		if filterKey == 'status'
			statuses = [
				{
					id: @inventoryCountStatusEnum.OPEN
					name: @translate('inventory.count.status.' + @inventoryCountStatusEnum.OPEN)
				}
				{
					id: @inventoryCountStatusEnum.CLOSED
					name: @translate('inventory.count.status.' + @inventoryCountStatusEnum.CLOSED)
				}
			]

			return @InventoryCountRepository.resolve(statuses)
